<template>
  <div class="flex flex-wrap">
    <div class="w-full md:w-3/4 md:pr-20">
      <h1 class="mt-2 mb-4 font-sans text-n-gray-dark">Account Details</h1>
      <form>
        <div class="mb-12">
          <label for="first_name">
            First name <span class="text-red">*</span>
          </label>
          <input id="first_name" type="text" name="first_name" v-validate="'required'" v-model="form.first_name" />
          <span v-show="errors.has('first_name')" class="error text-error-red text-lg">
            {{ errors.first('first_name') }}
          </span>
        </div>

        <div class="mb-12">
          <label for="last_name">
            Last name <span class="text-red">*</span>
          </label>
          <input id="last_name" type="text" name="last_name" v-validate="'required'" v-model="form.last_name" />
          <span v-show="errors.has('last_name')" class="error text-error-red text-lg">
            {{ errors.first('last_name') }}
          </span>
        </div>

        <div class="mb-12">
          <label for="email">
            Email <span class="text-red">*</span>
          </label>
          <input id="email" type="email" name="email" v-validate="'required|email'" v-model="form.email" />
          <span v-show="errors.has('email')" class="error text-error-red text-lg">
            {{ errors.first('email') }}
          </span>
        </div>

        <div class="mb-12">
          <label for="email">
            Phone
            <span class="block text-sm font-sans-book text-n-gray-dark">
              Optional, in case we need to contact you
            </span>
          </label>
          <input id="phone" type="tel" name="phone" v-model="form.phone" />
          <span v-show="errors.has('phone')" class="error text-error-red text-lg">
            {{ errors.first('phone') }}
          </span>
        </div>

        <div class="mb-12">
          <label for="password">
            Change Password
            <span class="block text-sm">
              Password should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number.
            </span>
          </label>
          <input id="password" type="password" name="password" v-validate="'min:8|upperCase|number|lowerCase'" v-model="form.password" />
          <span v-show="errors.has('password')" class="error text-error-red text-lg">
            {{ errors.first('password') }}
          </span>
        </div>

        <button class="button" @click.stop.prevent="validateUpdate">
          Update
        </button>
      </form>

      <div class="mb-12" />

      <OrganizationAdditionalInfo />
    </div>
    <div class="w-full md:w-1/4 md:pt-40">
      <div class="sidebar-block border-t-5 border-black pt-3">
        <public-profile-link></public-profile-link>
        <h2 class="text-lg mb-5 font-sans text-n-gray-dark">Help with My Account</h2>
        <ul class="list-reset mb-10 text-base">
          <li class="mb-2">
            <a target="_blank" href="https://help.letsreimagine.org/hc/en-us/sections/360008463452-Creating-your-account-and-public-profile">
              Profile and Account Guide
            </a>
          </li>
        </ul>

        <support />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Support from "../global/Support.vue";
import PublicProfileLink from "../global/PublicProfileLink.vue";
import OrganizationAdditionalInfo from "./components/OrganizationAdditionalInfo.vue";

export default {
  name: "UserProfile",
  title: "My Account",
  components: {
    OrganizationAdditionalInfo,
    Support,
    PublicProfileLink,
  },
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        isAdmin: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  watch: {
    user() {
      this.setUser();
    },
  },
  methods: {
    validateUpdate() {
      this.$validator.validate().then((result) => {
        if (!result) {
          return;
        }
        this.update();
      });
    },
    setUser() {
      this.form.first_name = this.user.firstName;
      this.form.last_name = this.user.lastName;
      this.form.email = this.user.email;
      this.form.phone = this.user.phone;
      this.form.squadupUserId = this.user.squadupUserId;
    },
    update() {
      const userId = this.user.id;

      let route = this.$laroute.route("api.users.update", {
        user: userId,
      });

      axios
        .put(route, this.form)
        .then((response) => {
          this.$store.dispatch("setUser", {
            user: response.data.data,
          });
          this.$toasted.show("Your account has been updated");
          this.form.password = null;
        })
        .catch((error) => {
          console.log("error", error.response);
        });
    },
  },
  mounted() {
    this.setUser();
  },
};
</script>
